// @ts-nocheck


import React, { useState } from 'react';
import Button from 'antd/lib/button';





import { Row, Spoiler } from './../../../../../../../components/ui';

import AssignmentLimitRow from './AssignmentLimitRow';


















/**
 * Компонент строки для групп лимитов в закреплении
 */
export default ({ group, index, onChange, onSave, editable }) => {
  const [hasChanges, setHasChanges] = useState(false);

  const handleChangeLimit = (
  limitIndex,
  name,
  value) =>
  {
    const { assignmentLimit } = group;
    const copy = [...assignmentLimit];
    copy[limitIndex][name] = value;

    onChange(index, 'assignmentLimit', copy);
    setHasChanges(true);
  };

  const handleSave = async () => {
    await onSave(group, index);
    setHasChanges(false);
  };
  return (
    <>
      <Spoiler
        label={group.regulationLimitGroup.name}
        labelStyles={{
          background: '#F0F4F8',
          color: '#838D96',
          height: '45px'
        }}
        defaultExpanded
        iconPlacement="left">

        {group.assignmentLimit.map((limit, index) =>
        <AssignmentLimitRow
          editable={editable}
          onChange={handleChangeLimit}
          limit={limit}
          index={index}
          key={index} />

        )}
        {editable && hasChanges &&
        <Row style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Button onClick={handleSave} size="small" type="primary">
              Сохранить изменения
            </Button>
          </Row>
        }
      </Spoiler>
    </>);

};
